import type { ReactNode } from "react";

interface StandardPageProps {
  children: ReactNode;
}

const StandardPage = ({ children }: StandardPageProps) => (
  <div className="mx-auto max-w-7xl px-6 sm:px-6 lg:px-8">{children}</div>
);

export default StandardPage;
